// removed by extract-text-webpack-plugin
module.exports = {"title":"_18iG-9uaoknRuyrqT87xFB","text":"wz4NcncHxpwVk-ZIxPQQo"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/FormFields/Title/styles.css
// module id = 3259
// module chunks = 0